import React from 'react';
import { add, differenceInMinutes, format, startOfDay } from 'date-fns';

import { ActionMenuItemType } from '@lyearn/molecules';
import { Stack, Typography } from '@lyearn/ui';

type GetTimeSuggestionsOptions = {
  referenceDate: Date;
  baseTime?: Date;
  showDuration: boolean;
};

export const getTimeSuggestions = ({
  referenceDate,
  baseTime,
  showDuration,
}: GetTimeSuggestionsOptions): ActionMenuItemType[] => {
  const dayStart = startOfDay(referenceDate);
  const allDaySlots = Array.from({ length: 96 }, (_, i) => add(dayStart, { minutes: i * 15 }));

  let nextSlotIndex = allDaySlots.findIndex((slot) => slot >= referenceDate);
  if (nextSlotIndex === -1) {
    nextSlotIndex = 0;
  }

  const rotatedSlots = allDaySlots.slice(nextSlotIndex).concat(allDaySlots.slice(0, nextSlotIndex));

  //@ts-ignore -> To support duration label at the end
  const items: ActionMenuItemType[] = rotatedSlots.map((date) => {
    let durationLabel: string | undefined;

    if (showDuration && baseTime) {
      if (date >= baseTime) {
        const totalMinutes = differenceInMinutes(date, baseTime);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        durationLabel = '';
        if (hours > 0) {
          durationLabel += `${hours}h `;
        }
        if (minutes > 0) {
          durationLabel += `${minutes}m`;
        }

        if (durationLabel === '') {
          durationLabel = '0m';
        }
        durationLabel = durationLabel.trim();
      }
    }

    return {
      id: date.toISOString(),
      label: (
        <Stack alignItems="center" className="w-full" direction="row" justifyContent="between">
          <Typography variant="body-short-02">{format(date, 'p')}</Typography>
          {durationLabel && (
            <Typography className="text-text-secondary" variant="body-short-02">
              {durationLabel}
            </Typography>
          )}
        </Stack>
      ),
      type: 'item',
    };
  });
  return items;
};
